export default {
  EDIT_INLINE_IMAGE_FOCAL_POINT: '@WS_EDITOR/CUSTOM_UI/EDIT_INLINE_IMAGE_FOCAL_POINT',
  EDIT_BACKGROUND_IMAGE_FOCAL_POINT: '@WS_EDITOR/CUSTOM_UI/EDIT_BACKGROUND_IMAGE_FOCAL_POINT',
  AI_REWRITE: '@WS_EDITOR/CUSTOM_UI/AI_REWRITE',
  AI_WRITE: '@WS_EDITOR/CUSTOM_UI/AI_WRITE',
};
